import { useState } from 'react';
import { buildYahooFindings } from './yahooReview';
import './YahooFindings.css';

export default function YahooFindings({ result, rows, onJump }) {
  const [open, setOpen] = useState(true);
  const findings = buildYahooFindings(result, rows);
  if (!findings.length) return null;
  const errors = findings.filter((f) => f.type === 'm').length;
  return (
    <section className="yahoo-findings" aria-label="Yahoo annotations" data-testid="clw-issues-bar">
      <header className="yahoo-findings-header">
        <div>
          <h3>{findings.length} annotation{findings.length === 1 ? '' : 's'} flagged</h3>
          <p>{errors} errors · {findings.length - errors} warnings · Same findings counted in the summary above</p>
        </div>
        <button type="button" className="clw-issues-toggle" aria-expanded={open} onClick={() => setOpen(!open)}>{open ? 'Hide details' : 'Show details'}</button>
      </header>
      {open && <ol className="yahoo-findings-list">
        {findings.map((finding, index) => <li key={finding.id} className={`yahoo-finding ${finding.type}`}>
          <span className="yahoo-finding-number" aria-hidden="true">{index + 1}</span>
          <div className="yahoo-finding-content">
            <div className="yahoo-finding-meta"><span className="yahoo-finding-severity">{finding.type === 'm' ? 'Error' : 'Warning'}</span><span>{finding.scope}</span></div>
            <p>{finding.msg}</p>
          </div>
          {finding.rowId && <button type="button" className="yahoo-finding-jump" onClick={() => onJump(finding.rowId, finding.field)}>View row →</button>}
        </li>)}
      </ol>}
    </section>
  );
}
